import React from 'react';

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', message }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };
  return (
    <div className="flex w-full items-center justify-center py-12">
      <div className="text-center">
        <div className={`mx-auto ${sizeClasses[size]} animate-spin rounded-full border-2 border-gray-300 border-t-blue-600`}></div>
        {message && <p className="mt-2 text-sm text-gray-500">{message}</p>}
      </div>
    </div>
  );
};

